export class GeneralHubActions {
  readonly SITE_DOWN_NOTIFICATION: string = "SiteDownNotification";
}
